// extracted by mini-css-extract-plugin
export default {"MenuGroup--max-height":"bgu_a"};